import React from "react";
import { Link } from "react-router-dom";
import { Compass, Home, MapPin } from "lucide-react";
import SEO from "../components/SEO";

export default function NotFound() {
  return (
    <div className="min-h-[70vh] bg-[#0d0e12] flex items-center justify-center px-4 py-20 text-center font-sans">
      <SEO
        title="404 - Page Not Found | Mini Golf USA"
        description="The page you are looking for does not exist or has moved."
        noindex={true}
      />
      <div className="max-w-md w-full bg-[#181a20] border border-gray-800/80 rounded-2xl p-8 shadow-2xl">
        <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-red-500/10 border border-red-500/20 flex items-center justify-center text-[#e5243b]">
          <Compass className="w-8 h-8" />
        </div>
        <span className="inline-block px-3 py-1 rounded-full text-xs font-bold tracking-wider uppercase bg-red-500/10 text-red-400 mb-2">
          Error 404
        </span>
        <h1 className="text-2xl sm:text-3xl font-extrabold text-white tracking-tight">
          Page Not Found
        </h1>
        <p className="text-gray-400 mt-2 text-sm leading-relaxed">
          The link you followed may be broken or the page may have been removed. Explore our directory below.
        </p>
        <div className="mt-6 flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-xl bg-[#e5243b] text-white text-sm font-bold hover:bg-[#cf1c31] transition-all shadow-md"
          >
            <Home className="w-4 h-4" /> Home
          </Link>
          <Link
            to="/state/alabama"
            className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-xl bg-gray-800 text-gray-200 text-sm font-semibold hover:bg-gray-700 transition-all border border-gray-700"
          >
            <MapPin className="w-4 h-4 text-gray-400" /> Browse Alabama Courses
          </Link>
        </div>
      </div>
    </div>
  );
}
